import { cloneDeep } from 'lodash';
import { saveAs } from 'file-saver';

const CsvExporterService = {

	export({ header, data, filename }) {
		let d = cloneDeep(data);

		if(Array.isArray(header)) {
			d.unshift(header);
		}

		try {
			const output = this.stringifyCSV(d);
			this.exportCSV(filename, output);
		}
		catch(err) {
			console.error('Error generating CSV:', err);
		}
	},

	stringifyCSV(data) {
		if(!Array.isArray(data) || data.length === 0) {
			return '';
		}
		// Ensure all rows are arrays
		data = data.map((row) => Array.isArray(row) ? row : []);

		// Convert each cell to string and escape as necessary
		return data.map((row) => {
			return row.map((cell) => {
				if(cell === null || cell === undefined) {
					return '';
				}

				const cellStr = String(cell);

				// Escape quotes and wrap in quotes if contains comma, quote, or newline
				if(cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n') || cellStr.includes('\r')) {
					return '"' + cellStr.replace(/"/g, '""') + '"';
				}

				return cellStr;
			}).join(',');
		}).join('\n');
	},

	exportCSV(filename, csv) {
		// Prepend a UTF-8 BOM so Excel detects the encoding instead of
		// defaulting to the OS legacy code page (e.g. Mac OS Roman) and
		// mangling accented characters.
		const content = csv.startsWith('\uFEFF') ? csv : '\uFEFF' + csv;
		const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
		saveAs(blob, filename);
	}
};

export default CsvExporterService;
